import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { MerchantSummaryState } from '../models/merchant.model';
import * as selectors from '../selectors/summary.selectors';

@Injectable()
export class MerchantSummaryFacadeService extends FacadeService {
  constructor(public override store: Store<MerchantSummaryState>) {
    super(store);
  }

  // OBSERVABLES
  couponsetsPanelStatus$ = this.storeSelect(selectors.getCouponsetsPanelStatus);
  storesPanelStatus$ = this.storeSelect(selectors.getStoresPanelStatus);
  companyName$ = this.storeSelect(selectors.getCompanyName);
  websiteURL$ = this.storeSelect(selectors.getWebsiteURL);
  memberSince$ = this.storeSelect(selectors.getMemberSince);
  officialBrandName$ = this.storeSelect(selectors.getOfficialBrandName);
  vatNumber$ = this.storeSelect(selectors.getVATNumber);
  qivosID$ = this.storeSelect(selectors.getQivosID);
  subscriptionPlan$ = this.storeSelect(selectors.getSubscriptionPlan);
  merchantActive$ = this.storeSelect(selectors.getMerchantActive);
  merchantInactive$ = this.storeSelect(selectors.getMerchantInactive);
  totalCoupons$ = this.storeSelect(selectors.getTotalCoupons);
  availableCoupons$ = this.storeSelect(selectors.getAvailableCoupons);
  givenCoupons$ = this.storeSelect(selectors.getGivenCoupons);
  stores$ = this.storeSelect(selectors.getStores);
  storesFilter$ = this.storeSelect(selectors.getStoresFilter);
  couponsets$ = this.storeSelect(selectors.getCouponsets);
  couponSet$ = this.storeSelect(selectors.getCouponSet);
  canDeactivateMerchant$ = this.storeSelect(selectors.getCanDeactivateMerchant);
  sidenavStatus$ = this.storeSelect(selectors.getSidenavStatus);

  // OBSERVABLES VALUES
  get couponsetsPanelStatus() {
    return this.storeSnapshot(this.couponsetsPanelStatus$);
  }

  get storesPanelStatus() {
    return this.storeSnapshot(this.storesPanelStatus$);
  }

  get qivosID() {
    return this.storeSnapshot(this.qivosID$);
  }

  get stores() {
    return this.storeSnapshot(this.stores$);
  }

  get couponsets() {
    return this.storeSnapshot(this.couponsets$);
  }

  get couponSets() {
    return this.storeSnapshot(this.couponsets$);
  }

  get couponSet() {
    return this.storeSnapshot(this.couponSet$);
  }

  get companyName() {
    return this.storeSnapshot(this.companyName$);
  }
}
